export default function(Vue) {
  Vue.audience = {
    getPreparedAudience(audience) {
      let preparedData = {
        followers: [],
        quality_distribution: [],
        city: [],
        lang: [],
        age: [],
        gender: []
      }
      preparedData.followers = audience.followers.map(function (v) {
        return {
          id: 0,
          k: v.key,
          v: Math.round(v.percent * 100 * 100) / 100
        }
      });
      preparedData.quality_distribution = audience.quality_distribution.map(function (v) {
        return {
          id: 0,
          k: v.key,
          v: Math.round(v.percent * 100 * 100) / 100
        }
      });
      preparedData.city = audience.city.map(function (v) {
        return {
          id: 0,
          k: v.key,
          v: Math.round(v.percent * 100 * 100) / 100
        }
      });
      const citySum = audience.city.map(function (v) {
        return Math.round(v.percent * 100 * 100) / 100;
      }).reduce((partialSum, a) => partialSum + a, 0);
      console.log(citySum);
      if (citySum < 100) {
        preparedData.city.push({
          id: 0,
          k: 'other',
          v: 100 - citySum
        });
      }
      preparedData.lang = audience.lang.map(function (v) {
        return {
          id: 0,
          k: v.key,
          v: Math.round(v.percent * 100 * 100) / 100
        }
      });
      preparedData.age = audience.age.map(function (v) {
        return {
          id: 0,
          k: v.key,
          v: Math.round(v.percent * 100 * 100) / 100
        }
      });
      preparedData.gender = audience.gender.map(function (v) {
        return {
          id: 0,
          k: parseInt(v.key),
          v: Math.round(v.percent * 100 * 100) / 100
        }
      });
      return preparedData;
    },
    audienceFollowers: [{
      id: 0,
      k: 'ghost_followers',
      v: ''
    }, {
      id: 0,
      k: 'mass_followers',
      v: ''
    }, {
      id: 0,
      k: 'influencer',
      v: ''
    }, {
      id: 0,
      k: 'real_people',
      v: ''
    }],
    audienceQualityDistribution: [{
      id: 0,
      k: 'verygood',
      v: ''
    }, {
      id: 0,
      k: 'good',
      v: ''
    }, {
      id: 0,
      k: 'medium',
      v: ''
    }, {
      id: 0,
      k: 'bad',
      v: ''
    }, {
      id: 0,
      k: 'verybad',
      v: ''
    }
    ],
    audienceAge: [{
      id: 0,
      k: '13.0-17.0',
      v: ''
    }, {
      id: 0,
      k: '18.0-24.0',
      v: ''
    }, {
      id: 0,
      k: '25.0-34.0',
      v: ''
    }, {
      id: 0,
      k: '35.0-44.0',
      v: ''
    }, {
      id: 0,
      k: '45.0-54.0',
      v: ''
    }, {
      id: 0,
      k: '55.0-64.0',
      v: ''
    }, {
      id: 0,
      k: '65.0-*',
      v: ''
    }],
    audienceGender: [{
      id: 0,
      k: 1,
      v: ''
    }, {
      id: 0,
      k: 2,
      v: ''
    }
    ]

  };

  Object.defineProperties(Vue.prototype, {
    $audience: {
      get() {
        return Vue.audience;
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/packages/audience/Audience.js